export const MANDATORY_FIELDS = [
  { path: ["personalInfo", "name"], label: "Name", id: "name" },
  { path: ["personalInfo", "iAm"], label: "I am", id: "iAm" },
  {
    path: ["personalInfo", "maritalStatus"],
    label: "Marital Status",
    id: "maritalStatus",
  },
  { path: ["birthDetails", "dob", "date"], label: "Date of Birth", id: "date" },
  { path: ["birthDetails", "dob", "time"], label: "Birth Time", id: "time" },
  { path: ["horoscopeDetails", "rasi"], label: "Rasi", id: "rasi" },
  {
    path: ["horoscopeDetails", "nakshatra"],
    label: "Nakshatra",
    id: "nakshatra",
  },
  // { path: ["horoscopeDetails", "padham"], label: "Padham", id: "padham" },
  { path: ["lookingFor"], label: "Looking For", id: "lookingFor" },
];

export const isFieldEmpty = (val) => {
  if (val === null || val === undefined) return true;
  const strVal = String(val).trim().toLowerCase();
  return strVal === "" || strVal === "select";
};

export const getFieldValue = (obj, path) => {
  return path.reduce((acc, part) => acc && acc[part], obj);
};

export const getMissingMandatoryFields = (profile) => {
  const missing = [];
  for (const field of MANDATORY_FIELDS) {
    const val = getFieldValue(profile, field.path);
    if (isFieldEmpty(val)) {
      missing.push(field);
    }
  }
  return missing;
};

export const checkMandatoryFieldsEmpty = (profile) => {
  return getMissingMandatoryFields(profile).length > 0;
};
